import {importWithPermission} from '@/utils/index'
import { PublicModulesRouteMap } from '@/new-router/public-modules'
import { BillingManagementRouteMap } from '@/new-router/billing-management'
import { UserCenterRouteMap } from '@/new-router/user-center'
import { ProductCenterRouteMap } from '@/new-router/product-center'
import { FinancialManagementRouteMap } from '@/new-router/financial-management'
const UserList = () => importWithPermission(import('@/views/User/userList'), 'user:list')
const userRegister = () => import('@/views/User/userRegister')
const userInformation = () => importWithPermission(import('@/views/User/userInformation'), 'user:information')
const userRechargeRecord = () => import('@/views/User/userRechargeRecord')
const userConsumerBill = () => import('@/views/User/userConsumerBill')
const professionalRenderingUpdateRecord = () => import('@/views/User/professionalRenderingUpdateRecord')
const copyrightRegistrationRecord = () => import('@/views/User/copyrightRegistrationRecord')
const agentsApplication = () => import('@/views/User/agentsApplication')
// const userMessageBoard = () => import('@/views/User/userMessageBoard')
const studentCertification = () => import('@/views/User/studentCertification')
// const enterpriseCertification = () => import('@/views/User/enterpriseCertification')
const clientFeedback = () => import('@/views/User/clientFeedback')
const pictureClientFeedback = () => import('@/views/User/picture-client-feedback')
const animationClientFeedback = () => import('@/views/User/animation-client-feedback')
const userBlackList = () => import('@/views/User/userBlackList')
const verifyBills = () => import('@/views/User/verifyBills')
const userDuplicationCheck = () => import('@/views/User/user-duplication-check')
const Home = () => import('@/views/Home/home')
/**
* hidden: true                   是否显示在侧栏上
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
**/

export default [
  {
    path: '/user',
    name: 'user',
    component: Home,
    meta: {
      title: '用户管理',
      icon: 'icon-user',
      showSubiems: false,
      sort: 4,
      permission: 'user:root',
      modules: 'user',
    },
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: UserList,
        meta: {
          title: '用户列表',
          active: ['userList', 'userInformation'],
          permission: 'user:list',
          belong: [UserCenterRouteMap.UserCenter, UserCenterRouteMap.UserManagement],
        },
      }, {
        path: 'userBlackList',
        name: 'userBlackList',
        component: userBlackList,
        meta: {
          title: '邮箱黑名单',
          active: ['userBlackList'],
          permission: 'user:blacklist',
          belong: [UserCenterRouteMap.UserCenter, UserCenterRouteMap.UserManagement],
        },
      }, {
        path: 'userRegister',
        name: 'userRegister',
        component: userRegister,
        meta: {
          title: '后台人工注册',
          active: ['userRegister'],
          permission: 'user:register',
          belong: [UserCenterRouteMap.UserCenter, UserCenterRouteMap.UserManagement],
        },
      }, {
        path: 'userInformation/:userId',
        name: 'userInformation',
        component: userInformation,
        hidden: true,
        meta: {
          nocache: true,
          title: '用户信息',
        },
      }, {
        path: 'userRechargeRecord',
        name: 'userRechargeRecord',
        component: userRechargeRecord,
        meta: {
          title: '用户充值与消费记录',
          active: ['userRechargeRecord'],
          permission: 'user:recharge',
          belong: [BillingManagementRouteMap.BillingManagement, BillingManagementRouteMap.BillingManagement],
        },
      }, {
        path: 'userConsumerBill',
        name: 'userConsumerBill',
        component: userConsumerBill,
        meta: {
          title: '消费账单',
          active: ['userConsumerBill'],
          permission: 'user:consume:bill',
          belong: [BillingManagementRouteMap.BillingManagement, BillingManagementRouteMap.BillingManagement],
        },
      }, {
        path: 'professionalRenderingUpdateRecord',
        name: 'professionalRenderingUpdateRecord',
        component: professionalRenderingUpdateRecord,
        meta: {
          title: '效果图会员升级记录',
          active: ['professionalRenderingUpdateRecord'],
          permission: 'user:recharge:picture',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.RenderingOfRenderings],
        },
      },
      {
        path: 'copyrightRegistrationRecord',
        name: 'copyrightRegistrationRecord',
        component: copyrightRegistrationRecord,
        meta: {
          title: '版权登记',
          active: ['copyrightRegistrationRecord'],
          permission: 'user:copyrightRegister',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.IpCopyright],
        },
      },
      {
        path: 'studentCertification',
        name: 'studentCertification',
        component: studentCertification,
        meta: {
          title: '学生认证',
          active: ['studentCertification'],
          permission: 'user:student',
          belong: [UserCenterRouteMap.UserCenter, UserCenterRouteMap.UserManagement],
        },
      },
      // {
      //   path: 'enterpriseCertification',
      //   name: 'enterpriseCertification',
      //   component: enterpriseCertification,
      //   meta: {
      //     title: '企业认证',
      //     active: ['enterpriseCertification'],
      //     permission: 'user:enterprise',
      //   },
      // },
      //  {
      //   path: 'userMessageBoard',
      //   name: 'userMessageBoard',
      //   component: userMessageBoard,
      //   meta: {
      //     title: '用户留言',
      //     active: ['userMessageBoard'],
      //     permission: 'user:message',
      //   },
      // },
      {
        path: 'agentsApplication',
        name: 'agentsApplication',
        component: agentsApplication,
        meta: {
          title: '代理商申请',
          active: ['agentsApplication'],
          permission: 'user:agent:apply',
          belong: [UserCenterRouteMap.UserCenter, UserCenterRouteMap.AgencyManagement],
        },
      }, {
        path: 'clientFeedback',
        name: 'clientFeedback',
        component: clientFeedback,
        meta: {
          title: 'Fox动画客户端意见反馈',
          active: ['clientFeedback'],
          permission: 'user:foxFeedback',
          sort: 4,
          belong: [
            PublicModulesRouteMap.PublicModules,
            PublicModulesRouteMap.FeedbackManagement,
          ],
        },
      }, {
        path: 'pictureClientFeedback',
        name: 'pictureClientFeedback',
        component: pictureClientFeedback,
        meta: {
          title: '效果图客户端意见反馈',
          active: ['pictureClientFeedback'],
          permission: 'user:picFeedback',
          sort: 5,
          belong: [
            PublicModulesRouteMap.PublicModules,
            PublicModulesRouteMap.FeedbackManagement,
          ],
        },
      },
      {
        path: 'animationClientFeedback',
        name: 'animationClientFeedback',
        component: animationClientFeedback,
        meta: {
          title: '动画客户端意见反馈',
          active: ['animationClientFeedback'],
          permission: 'user:client:feedback',
          sort: 5,
          belong: [
            PublicModulesRouteMap.PublicModules,
            PublicModulesRouteMap.FeedbackManagement,
          ],
        },
      },
      {
        path: 'verifyBills',
        name: 'verifyBills',
        component: verifyBills,
        meta: {
          title: '财务对账',
          active: ['verifyBills'],
          permission: 'user:financeVerifyBills',
          belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialReconciliation],
        },
      },
      {
        path: 'userDuplicationCheck',
        name: 'userDuplicationCheck',
        component: userDuplicationCheck,
        meta: {
          title: '用户查重',
          active: ['userDuplicationCheck'],
          permission: 'user:list:check',
          belong: [UserCenterRouteMap.UserCenter, UserCenterRouteMap.UserManagement],
        },
      },
    ],
  },
]
